import { directions } from 'configs';

// eslint-disable-next-line no-prototype-builtins
const isDirection = (value) => directions.hasOwnProperty(value);

export default isDirection;
